//
//
//
//


export default {
  props: {
    value: Number
  }
}
